// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { Multilang, MultilangObj } from '../../types/Model';

interface Props {
  value: any;
  lang?: string;
}

const langOrder = [
  'cht',
  'eng',
  'chs'
]

export function getMultilang(value?: Multilang, defaultLang = 'cht') {
  for (const lang of [defaultLang, ...langOrder]) {
    if (value && value[lang])
      return value[lang]
  }

  return '';
}

export function getMultilangs(array: MultilangObj[]) {
  return array.map(({ id, names, ...item }) => ({
    ...item,
    id,
    name: getMultilang(names)
  }))
}

export default function(props: Props) {
  const { value, lang = 'cht' } = props;

  return (
    <>{getMultilang(value, lang)}</>
  )
}
